export default __webpack_public_path__ + "static/media/accountingclose-12.9e24c7d6.svg";